import { Route, Routes } from "react-router-dom";
import { CommodityTypePage } from "./pages/CommodityTypePage";

const CommodityType = () => {
  return (
    <Routes>
      <Route index element={<CommodityTypePage />} />
      <Route path=":commodityTypeId" element={<CommodityTypePage />} />
    </Routes>
  );
};
export default CommodityType;
